import { NgModule } from '@angular/core';
import { LemsarApiModule } from '@lemsar/api/api.module';
import { LemsarAuthDomainModule } from '@lemsar/auth/domains/module';
import { LemsarAuthViewModule } from '@lemsar/auth/views/module';
import { GuestGuard } from '@lemsar/auth/guards/guest.guard';
import { AUTH_ROUTING } from '@lemsar/auth/auth.routes';
import { AuthenticatedGuard } from '@naker/naco';
import { LemsarCommonDomainModule } from '@lemsar/common/domains/module';
import { UploaderModule } from '@shared/module/uploader/uploader.module';
import { AuthService } from '@lemsar/auth/domains/services/auth.service';
import { RegisteredGuard } from '@lemsar/auth/guards/registered.guard';
import { UnregisteredGuard } from '@lemsar/auth/guards/unregistered.guard';
import { RedirectUriGuard } from '@lemsar/auth/guards/redirect-uri.guard';

@NgModule({
    imports: [LemsarApiModule, LemsarAuthDomainModule, LemsarAuthViewModule, AUTH_ROUTING, LemsarCommonDomainModule, UploaderModule],
    providers: [GuestGuard, AuthenticatedGuard, RegisteredGuard, UnregisteredGuard, RedirectUriGuard, AuthService],
})
export class LemsarAuthModule {}



// WEBPACK FOOTER //
// ./src/lemsar/auth/auth.module.ts